enum SalesTypeCodeEnum {
	aisleAndBin = 'AISLE_AND_BIN', // SELF_SERVE - Prev self_serve
	department = 'DEPARTMENT', // MARKET_HALL/SHOWROOM - Prev satellite
	contactStaff = 'CONTACT_STAFF' // WAREHOUSE - Prev full_serve/dds
}

export default SalesTypeCodeEnum;
